import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import { useAuth } from '../auth/AuthContext';

import MenuButton from './MenuButton';
import MenuContent from './MenuContent';
// import CardAlert from './CardAlert';

function SideMenuMobile({ open, toggleDrawer }) {
  const { session, logout } = useAuth();

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: 'none',
          backdropFilter: 'blur(18px)',
          background: (theme) => theme.vars
            ? `linear-gradient(180deg, rgba(${theme.vars.palette.background.paperChannel} / 0.74) 0%, rgba(${theme.vars.palette.background.defaultChannel} / 0.9) 100%)`
            : `linear-gradient(180deg, ${alpha(theme.palette.background.paper, 0.74)} 0%, ${alpha(theme.palette.background.default, 0.9)} 100%)`,
        },
      }}
    >
      <Stack
        sx={{
          maxWidth: '70dvw',
          height: '100%',
        }}
      >
        <Stack direction="row" sx={{ p: 2, pb: 0, gap: 1 }}>
          <Stack
            direction="row"
            sx={{ gap: 1, alignItems: 'center', flexGrow: 1, p: 1 }}
          >
            <Avatar
              sizes="small"
              alt="Admin"
              src="/favicon.svg"
              sx={{ width: 28, height: 28 }}
            />
            <Stack spacing={0}>
              <Typography component="p" variant="subtitle2">
                EV Dashboard
              </Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                {session?.userId || 'Guest'}
              </Typography>
            </Stack>
          </Stack>
          <MenuButton showBadge>
            <NotificationsRoundedIcon />
          </MenuButton>
        </Stack>
        <Divider />
        <Stack sx={{ flexGrow: 1 }}>
          <MenuContent onNavigate={toggleDrawer(false)} />
          <Divider />
        </Stack>
        {/* <CardAlert /> */}
        <Stack sx={{ p: 2 }}>
          <Button variant="outlined" fullWidth startIcon={<LogoutRoundedIcon />} onClick={logout}>
            Logout
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
}

SideMenuMobile.propTypes = {
  open: PropTypes.bool,
  toggleDrawer: PropTypes.func.isRequired,
};

export default SideMenuMobile;
